var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-dialog',{attrs:{"title":_vm.subject,"visible":_vm.showDialog,"width":"650px","append-to-body":"","close-on-click-modal":false},on:{"update:visible":function($event){_vm.showDialog=$event},"open":_vm.loadTicket,"close":_vm.closeDialog}},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.body)}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01883cb1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./ClientApp/app/emails/components/emailDetailsDialog.vue
// module id = GQ0N
// module chunks = 1